export default "__VITE_ASSET__CGpKvyeo__"